import lazysizes from 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';

document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
window.lazysizes = lazysizes;
